import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];
  static values = {
    autoClose: { type: String, default: "true" },
    modal: { type: Boolean, default: false },
  };

  toggle(event) {
    event.preventDefault();
    const open = this.menuTarget.classList.toggle("show");
    event.currentTarget.setAttribute("aria-expanded", open);
    this._syncModal(open);
  }

  close() {
    this.menuTarget.classList.remove("show");
    const toggle = this.element.querySelector("[aria-expanded]");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
    this._syncModal(false);
  }

  closeOnClickOutside(event) {
    if (this.autoCloseValue === "false") return;
    if (!this.element.contains(event.target)) return this.close();
    // "outside" mode: don't close on clicks inside the menu
    if (this.autoCloseValue === "outside") return;
    // "true" mode: close on clicks inside the menu (but not the toggle, handled by toggle())
    if (this.menuTarget.contains(event.target)) this.close();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  connect() {
    this._outsideClick = (e) => this.closeOnClickOutside(e);
    this._escape = (e) => this.closeOnEscape(e);
    this._beforeCache = () => this.close();
    document.addEventListener("click", this._outsideClick);
    document.addEventListener("keydown", this._escape);
    document.addEventListener("turbo:before-cache", this._beforeCache);
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick);
    document.removeEventListener("keydown", this._escape);
    document.removeEventListener("turbo:before-cache", this._beforeCache);
    this._syncModal(false);
  }

  _syncModal(isOpen) {
    if (!this.modalValue) return;

    document.body.style.overflow = isOpen ? "hidden" : "";

    // Inert navbar siblings so tab/screenreader can't reach them
    const navbar = this.element.closest(".navbar__inner");
    if (navbar) {
      for (const child of navbar.children) {
        if (child !== this.element) child.toggleAttribute("inert", isOpen);
      }
    }

    // Inert page content behind the popover
    document.querySelector("main")?.toggleAttribute("inert", isOpen);
    document.querySelector("footer")?.toggleAttribute("inert", isOpen);
  }
}
